import { Settings } from "lucide-react";
import CardSolicitudProducto from "./card-solicitud-producto";

export default function KanbanSolicitudProductoColumn({
    title,
    items = [],
    onCardClick,
    onAcceptCard,
    onRejectCard,
    onConfigureActions,
    selectedItemId = null,
    emptyLabel = "—",
}) {
    return (
        <div className="flex flex-col w-full bg-gray-50 border border-gray-200 rounded-lg overflow-hidden">
            <div className="px-3 py-2.5 border-b border-gray-200 bg-white">
                <div className="flex items-start justify-between gap-2 min-w-0">
                    <h3 className="text-sm font-semibold text-gray-900 min-w-0 flex-1 break-words">
                        {title}
                    </h3>
                    <div className="flex items-center gap-2 shrink-0">
                        <button
                            type="button"
                            onClick={onConfigureActions}
                            className="p-1 rounded text-gray-400 hover:text-gray-700 hover:bg-gray-100"
                        >
                            <Settings className="h-4 w-4" />
                        </button>
                        <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full shrink-0">
                            {items.length}
                        </span>
                    </div>
                </div>
            </div>
            <div className="flex-1 min-h-[280px] max-h-[calc(100vh-320px)] overflow-y-auto p-2 space-y-2">
                {items.length === 0 ? (
                    <div className="flex items-center justify-center h-24 text-xs text-gray-400 border border-dashed border-gray-200 rounded-lg">
                        {emptyLabel}
                    </div>
                ) : (
                    items.map((item) => (
                        <CardSolicitudProducto
                            key={item.id}
                            item={item}
                            onClick={onCardClick}
                            onAccept={onAcceptCard}
                            onReject={onRejectCard}
                            selected={selectedItemId != null && item.id === selectedItemId}
                        />
                    ))
                )}
            </div>
        </div>
    );
}
